import React, { useEffect, useState } from 'react';
import { ApiRequest } from 'GlobalFunctions';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import ImageUploader from 'elements/ImageUploader';
import ImageViewer from './ImageViewer';
import IconButton from '@mui/material/IconButton';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import AlertDialog from 'elements/AlertDialog';

interface ConversationProps {
  conversationId: string;
}

const defaultValues = {
  message_text: '',
  image: '',
  conversation_id: '',
};


export default function Conversation({ conversationId }: ConversationProps) {
  const [messages, setMessages] = useState<any>([]);
  const [formValues, setFormValues] = useState<any>(defaultValues);
  const [files, setFiles] = useState<any>([]);
  const [openImageViewer, setOpenImageViewer] = useState(false);
  const [selectedImage, setSelectedImage] = useState('');
  const [openAlert, setOpenAlert] = useState(false);
  const [activeMessage, setActiveMessage] = useState<any>(null);
  const [is_admin, setIsAdmin] = useState(false);

  const getMessages = async () => {
    await ApiRequest({
      url: `/messages/globalMessages`,
      method: 'GET',
      query: {
         conversation_id: conversationId
      },
      setResponse: (response: any) => {
        setMessages(response.messages);
        setIsAdmin(response.is_admin);
      },
    });
  }

  useEffect(() => {
    getMessages();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [conversationId]);

  useEffect(() => {
    const conversationContainer = document.querySelector('.conversation_container');
    if (conversationContainer) {
      setTimeout(() => {
        conversationContainer.scrollTop = conversationContainer.scrollHeight;
      }, 100); // Adjust the timeout duration if necessary
    }
  }, [messages]);

  const handleSendMessage = async () => {
    
    if (formValues.message_text.trim() === '' && files.length === 0) return;

    formValues.conversation_id = conversationId;

    const body = new FormData();
    body.append('formValues', JSON.stringify(formValues));
    console.log(files);
    if (files) {
      body.append("image", files);
  }

    await ApiRequest({
      url: '/messages/send',
      method: 'POST',
      formData: true,
      body: body,
      setResponse: (response: any) => {
        if (response.status === 'success') {
          getMessages();
          setFormValues(defaultValues);
          setFiles([]);
        }
      },
    });
  };

  const handleDelete = (message_id: number) => {
    setActiveMessage(message_id);
    setOpenAlert(true);
  };

  const deleteMessage = async () => {
    await ApiRequest({
      url: `/messages/deleteMessage`,
      method: 'POST',
      body: { message_id: activeMessage },
      setResponse: (response: any) => {
        if (response.status === 'success') {
          getMessages();
          setOpenAlert(false);
        }
      },
    });
  };

  return (
    <>
    <div className='conversation_container'>
        {messages.length > 0 && messages.map((message: any, index: any) => {
          const isPlaceholder = message.message_text?.startsWith('[AUTO_PLACEHOLDER]');
          const displayText = isPlaceholder
            ? message.message_text.replace('[AUTO_PLACEHOLDER] ', '')
            : message.message_text;
          return (
          <div
            key={index}
            className={message.is_owner ? 'message_container_owner' : 'message_container_other'}
          >
            <div className='message_bubble' style={isPlaceholder ? { background: '#fff8e1', border: '1px solid #ffe082', color: '#795548' } : {}}>

              {message.image &&
                <img
                  src={message.image}
                  alt=""
                  className='message_image'
                  onClick={() => {
                    setSelectedImage(message.image);
                    setOpenImageViewer(true);
                  }}
                />
              }

              {displayText}

              <div className='message_footer'>
                <div className='message_date'>
                  {message.sent_at}
                </div>
                <div className='message_author'>
                  {message.sender_username + ' ' + message.sender_lastname}
                </div>
              </div>
              
              
            </div>
            <div className='message_delete_container'>
              <IconButton className='delete_message' aria-label="delete" color="error" onClick={() => handleDelete(message.message_id)}>
                  <DeleteOutlineOutlinedIcon />
                </IconButton>
              </div>
          </div>
          );
        })}
    </div>
    {is_admin && (
      <div className='message_input_container'>
        <ImageUploader 
            className="message_image_uploader"
            image={formValues.image}
            setImage={(newImage) => setFormValues({ ...formValues, image: newImage })}
            setFiles={setFiles} 
            label=""
        />
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Escribe un mensaje..."
          value={formValues.message_text}
          onChange={(e) => setFormValues({ ...formValues, message_text: e.target.value })}
          style={{ marginLeft: '10px' }}
        />
        <Button variant="contained" color="primary" onClick={handleSendMessage} style={{ marginLeft: '10px' }}>
          Enviar
        </Button>
      </div>
    )}

    <ImageViewer
      open={openImageViewer}
      imageSrc={selectedImage}
      onClose={() => setOpenImageViewer(false)}
    />

    <AlertDialog
      open={openAlert}
      setOpen={setOpenAlert}
      subtitle="¿Está seguro que desea eliminar este mensaje?"
      send={deleteMessage}
    />
    </>
  );
}
